<ng-container *ngIf="nzLoading">
  <div class="ant-skeleton-header" *ngIf="!!nzAvatar && !uiCustom">
    <ui-skeleton-element [uiSize]="avatar.size || 'default'" [uiShape]="avatar.shape || 'circle'" uiType="avatar"></ui-skeleton-element>
  </div>
  <div class="ant-skeleton-content">
    <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
    <h3 class="ant-skeleton-title" *ngIf="!!nzTitle && !uiCustom" [style.width]="toCSSUnit(title.width)" [ngClass]="uiSectionHeight.title"></h3>
    <ul class="ant-skeleton-paragraph" *ngIf="!!nzParagraph && !uiCustom">
      <li *ngFor="let row of rowsList; let i = index" [style.width]="toCSSUnit(widthList[i])" [ngClass]="uiSectionHeight.paragraph"></li>
    </ul>
    <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
    <h3
      class="ant-skeleton-title"
      *ngIf="uiCustom"
      [style.width]="toCSSUnit(uiCustomMeasurements.width)"
      [style.height]="toCSSUnit(uiCustomMeasurements.height)"
      [style.margin]="toCSSUnit(uiCustomMeasurements.margin)"></h3>
  </div>
</ng-container>
<ng-container *ngIf="!nzLoading">
  <ng-content></ng-content>
</ng-container>
